<template>
  <div class="push">
    <div class="infoContent">
      <div class="text">
        {{ pushTextItem.message }}
        <p v-if="pushTextItem.module !== 'eld-task-leave'">
          <span style="font-size: 12px" @click="detail(pushTextItem.taskId, pushTextItem)">
            Check out now
          </span>
        </p>
      </div>
    </div>

    <div class="time">
        {{ currentDate(pushTextItem.created_time) }}
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
  props: ["pushTextItem"],
  methods: {
    detail(id, data) {
      if (data && data.module === 'dispatcher-eld') {
        this.$router.push({
          path: '/setting/eld/add-integration'
        })
      } else {
        this.$router.push({
          path: "/load/details",
          query: {
            id: id,
          },
        });
      }
      
    },
    currentDate(time) {
      return moment(time).format("HH:mm A");
    },
  },
};
</script>

<style scoped lang="scss">
.push {
  display: flex;
  flex-direction: column;

  .infoContent {
    display: flex;
    align-items: flex-end;
    margin-bottom: 6px;
  }

  .text {
    color: #000;
    background-color: #fff;
    border-radius: 20px 20px 20px 0;
    overflow: hidden;
    min-width: 40px;
    max-width: 260px;
    padding: 10px 16px;
    font-weight: 500;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    display: flex;
    flex-direction: column;

    p {
      color: #4066d4;
      font-size: 12px;
      margin-top: 8px;

      span {
        cursor: pointer;
        font-weight: bold;
      }
    }

    img {
      border-radius: 20px 20px 20px 0;
    }
  }

  .time {
    width: 100%;
    height: 16px;
    line-height: 16px;
    color: #a1afc4;
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 16px;
  }
}
</style>
